import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  workId: string;
  variant?: "solid" | "ghost";
}

export default function FavoriteButton({ workId, variant = "solid" }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(workId);
  const [toast, setToast] = useState<string | null>(null);

  const handleClick = () => {
    const nowActive = toggleFavorite(workId);
    setToast(nowActive ? "已加入收藏" : "已取消收藏");
    window.setTimeout(() => setToast(null), 1800);
  };

  const base =
    "inline-flex items-center gap-2 h-11 px-6 rounded-md font-label text-sm transition-colors cursor-pointer whitespace-nowrap";
  const styles =
    variant === "solid"
      ? active
        ? "bg-accent-500 text-accent-950 hover:bg-accent-600"
        : "bg-background-50 text-foreground-800 border border-background-300 hover:border-accent-400"
      : active
        ? "bg-background-50/20 text-background-50 border border-background-50/40"
        : "bg-background-50/15 text-background-50 border border-background-50/30 hover:bg-background-50/25";

  return (
    <div className="relative">
      <button type="button" onClick={handleClick} className={`${base} ${styles}`} aria-pressed={active}>
        <i className={active ? "ri-heart-fill" : "ri-heart-line"}></i>
        {active ? "已收藏" : "收藏"}
      </button>
      {toast && (
        <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-3 py-1.5 rounded-md bg-primary-950 text-background-50 text-xs font-label whitespace-nowrap animate-soft-in">
          {toast}
        </div>
      )}
    </div>
  );
}